import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// API
import * as API from '../../utils/api';

// Components
import Header from '../../components/Global/Header';
import FormContainer from '../../components/Global/FormContainer';
import FormInput from '../../components/Global/Forms/FormInput';
import FlashMessage from '../../components/Global/FlashMessage';

// Utils
import {
  validateEmail,
} from '../../utils/helpers';

class ResetPassword extends Component {

  state = {
    input: {
      email: '',
    },
    formErrors: {
      email: '',
    },
    formIsValid: false,
    displayErrorMessages: false,
    flashMessage: {
      display: false,
      message: '',
      type: '',
    },
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      },
      logInErrorMessage: ''
    }), () => { this.updateFieldErrorMessage(name, value) });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { input } = this.state;

    if (this.isFormValid()) {
      API.requestResetPassword(input.email)
        .then(response => {
          if (response.success) {
            this.setState({
              flashMessage: {
                display: true,
                message: `A link to reset your password has been sent to ${input.email}`,
                type: '',
              }
            })
          } else if (response.errors.includes("Not found")) {
            this.setState({
              flashMessage: {
                display: true,
                message: `${input.email} does not exist in our system. Please try again.`,
                type: 'error',
              }
            })
          } else {
            console.log('Error resetting password.')
          }
        })
    } else {
      this.setFormErrorState();
    }
  }

  setFormErrorState = () => {
    const { input, displayErrorMessages } = this.state;

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  turnOnErrorMessages() {
    this.setState(state => ({
      ...state,
      displayErrorMessages: true
    }));
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state;

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }));
  }

  isFormValid() {
    const { input } = this.state;

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      return this.isFieldValid(field, input[field])
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false;
    } else {
      return true;
    }
  }

  isFieldValid = (fieldName, value) => {
    switch(fieldName) {
      case 'email':
        return validateEmail(value)
        // eslint-disable-next-line no-unreachable
        break;
      default:
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  updateFieldErrorMessage = (fieldName, value) => {
    let errorMessage = '';

    switch(fieldName) {
      case 'email':
        errorMessage = validateEmail(value)
          ? ''
          : 'Please enter a valid email'
        break;
      default:
        errorMessage = value.length > 0
          ? ''
          : 'Please complete this field';
        break;
    }

    this.setState(state => ({
      ...state,
      formErrors: {
        ...state.formErrors,
        [fieldName]: errorMessage
      }
    }));
  }

  handleInputBlur = (event) => {
    const { value, name } = event.target;
    const { formIsValid, displayErrorMessages } = this.state;

    this.updateFieldErrorMessage(name, value);

    if (!formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  renderFlashMessage() {
    const { flashMessage } = this.state;

    return flashMessage.display
    ? (
      <FlashMessage
        optionalClasses={`${flashMessage.type === 'error' ? 'error' : ''}`}
      >
        {flashMessage.message}
      </FlashMessage>
    )
    : ''
  }

  renderResetForm() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      flashMessage
    } = this.state;

    return flashMessage.display && flashMessage.type !== 'error'
    ? null
    : (
      <form onSubmit={this.handleSubmit}>
        <FormInput
          autoComplete="off"
          label="Email Address"
          placeholder="Email Address"
          name="email"
          type="email"
          value={input.email}
          onChange={this.handleInputChange}
          onBlur={this.handleInputBlur}
          showError={displayErrorMessages}
          errorMessage={formErrors.email}
        />
        <hr />
        <input type="submit" value="Reset Password" />
      </form>
    )
  }

  render() {
    const {
      appName,
      path,
      user
    } = this.props;

    return (
      <div className={`onboarding reset-password${user.isLoggedIn ? ' authenticated' : ''}`}>
        <Helmet>
          <title>{appName} | Reset Your Password</title>
        </Helmet>
        <Header path={ path }/>
        <FormContainer>
          <header>
            <h2>Reset Password</h2>
            <p>
              Enter the email address associated with your account, and we’ll email you a link to reset your password.
            </p>
          </header>
          {this.renderFlashMessage()}
          {this.renderResetForm()}
          {
            !user.isLoggedIn &&
            <div className="post-form-link">
              <Link to="/log-in" className="text-link">
                Back to Log In
              </Link>
            </div>
          }
        </FormContainer>
      </div>
    );
  }
}

const mapStateToProps =  state  => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  null
)(ResetPassword)



// WEBPACK FOOTER //
// ./src/screens/Sessions/ResetPassword.js